<template>
    <div id="account">
        <div class="pt-8 d-flex">
            <div class="sansation info--text d-inline"><h2>Account Information</h2></div>
        </div>
        <v-divider></v-divider>
        <v-row class="mt-9">
            <v-col cols="6" md="6" sm="6">
                <h3 class="mb-12 primary--text text--darken-1">Admin Account Information</h3>
                <div class="d-block">First Name</div>
                <v-text-field 
                    v-model="input.first_name" 
                    label="First Name" 
                    solo 
                    class="main_inputs d-block">
                </v-text-field>
                <div class="d-block">Last Name</div>
                <v-text-field 
                    v-model="input.last_name" 
                    label="Last Name" 
                    solo 
                    class="main_inputs d-block">
                </v-text-field>

                <v-btn 
                    @click="updateContact" 
                    color="primary darken-1" 
                    class="d-block"
                >
                    Submit Changes
                </v-btn>
            </v-col>
            <v-col cols="6" md="6" sm="6">
                <h3 class="mb-12 primary--text text--darken-1">Login Credentials</h3>
                <div class="d-block">Email Address</div>
                <v-text-field 
                    v-model.lazy="input.user_email" 
                    label="Email Address" 
                    solo 
                    :rules="emailRules" 
                    class="main_inputs d-block">
                </v-text-field>

                <v-text-field 
                    :append-icon="show_eye1 ? 'mdi-eye' : 'mdi-eye-off'"
                    v-model="input.password"
                    :type="show_eye1 ? 'text' : 'password'" 
                    :rules="[rules.required]" 
                    label="Password"
                    class="main_inputs d-block"
                    solo
                    @click:append="show_eye1 = !show_eye1">
                </v-text-field>

                <v-text-field 
                    :append-icon="show_eye2 ? 'mdi-eye' : 'mdi-eye-off'"
                    v-model="input.confirm_password" 
                    :type="show_eye2 ? 'text' : 'password'" 
                    :rules="[rules.required, rules.matches_pass]" 
                    label="Confirm Password"
                    class="main_inputs d-block"
                    solo
                    @click:append="show_eye2 = !show_eye2">
                </v-text-field>

                <v-btn 
                    @click="changeLogin" 
                    color="primary darken-1" 
                    class="d-block"
                >
                    Submit Changes
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import axios from 'axios'
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment'
    
    export default {
        name: 'Account',

        data () {
            return {
                input: {},
                reset_email: '',
                show_eye1: false,
                show_eye2: false,
                emailRules: [],
                rules: {
                    required: value => !!value || 'Required',
                    matches_pass: value => {
                        return value == this.input.password || 'Password does not match Confirmation'
                    },
                    matches_confirm: value => {
                        return value == this.input.confirm_password || 'Confirmation does not match Password'
                    }
                },
            }
        },

        watch: {
            reset_email: function (mail) {
                this.emailRules = [ v => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v) || 'Email must be valid' ]
            }
        },

        mounted() {
            this.getAccount();
        },

        methods: {
            getAccount: function () {
                axios.get(`${appUrls.api}/api/account/${Cookie.get('bool')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    if(res.data.outcome){
                        //console.log(res.data.contact);
                        this.input = res.data.contact;
                        //console.log(this.input);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            changeLogin: function () {
                axios.put(`${appUrls.api}/api/change_login/${Cookie.get('bool')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    user_email: this.input.user_email, 
                    password: this.input.password, 
                    confirm_password: this.input.confirm_password
                })
                .then( res => {
                    //console.log(res.data);
                    this.$feedback.trigger( true, res.data.message, res.data.outcome === false ? 'accent' : 'light-green' );
                })
                .catch( res => {
                    //console.log(res);
                    this.$feedback.error( res.message );
                });
            },

            updateContact: function () {
                axios.put(`${appUrls.api}/api/update_contact/${Cookie.get('bool')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    first_name: this.input.first_name, 
                    last_name: this.input.last_name
                })
                .then( res => {
                    // console.log(res.data);
                    this.$feedback.trigger( true, res.data.message, res.data.outcome === false ? 'accent' : 'light-green' );
                })
                .catch( res => {
                    //console.log(res);
                    this.$feedback.error( res.message );
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #account {
        padding: 40px;
        margin-top: 10px;
    }
    .main_inputs {
        width: 60%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue